import React, { useState } from 'react';
import { Description, Information, Layout, MetaSection, Title } from './TeaserElement.styles';
import { leadOrDescription } from '../../../../play-core/utils/string-helper';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { usePath, useVideoConfig } from '../../config/VideoAppContext';
import { SmartLink } from '../ClickableComponents/SmartLink';
import { teaserElementImageWidth } from '../Image/image-width';
import { InfoLabel } from '../InfoLabel/InfoLabel';
import { getDefaultLabelProps } from '../InfoLabel/label-helper';
import { MediaListTitle } from '../MediaListTitle/MediaListTitle';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { useSectionMeta } from '../Section/SectionMetaProvider';
import { AspectPlaceholder } from '../Teaser/Placeholder/AspectPlaceholder';
import { ShowTeaserWrapper } from '../Teaser/ShowTeaser/ShowTeaserWrapper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowElement = ({
  show,
  labelText,
  title = '',
  index
}) => {
  const [isHovering, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const {
    videoShowPath
  } = usePath();
  const {
    usePreview
  } = useVideoConfig();
  const analytics = useAnalyticsDispatch();
  const {
    sectionId,
    representationName,
    sectionTitle
  } = useSectionMeta();
  const label = getDefaultLabelProps(labelText);
  const description = leadOrDescription(show);
  return /*#__PURE__*/_jsxs(PlayContainer, {
    children: [/*#__PURE__*/_jsx(MediaListTitle, {
      title: title
    }), /*#__PURE__*/_jsxs(Layout, {
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
      children: [show ? /*#__PURE__*/_jsx(ShowTeaserWrapper, {
        show: show,
        index: index,
        hasBorderRadius: false,
        isHoveringParent: isHovering,
        isFocusedParent: isFocused,
        imageWidth: teaserElementImageWidth
      }) : /*#__PURE__*/_jsx(AspectPlaceholder, {
        aspectRatio: 16 / 9,
        isPreview: usePreview
      }), show && /*#__PURE__*/_jsx(SmartLink, {
        to: videoShowPath(show),
        isInternal: true,
        state: {
          show
        },
        onClick: () => {
          if (sectionId || representationName) {
            analytics({
              type: 'click-event',
              name: 'ShowElementInformationClick',
              value1: show.urn,
              value2: sectionId,
              value3: sectionTitle,
              value4: representationName
            });
          }
        },
        children: /*#__PURE__*/_jsxs(Information, {
          children: [/*#__PURE__*/_jsx(MetaSection, {
            children: label && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(InfoLabel, {
                type: label?.type,
                text: label?.text
              })
            })
          }), /*#__PURE__*/_jsx(Title, {
            children: show.title
          }), description && /*#__PURE__*/_jsx(Description, {
            children: description
          })]
        })
      })]
    })]
  });
};